/*
 * Shipping facts (v2) — fills in the "Order Today - Get By" estimate.
 * The business-day window comes from the block settings, read off the
 * element's data attributes, so the copy stays editable in the customizer.
 */
(function () {
  function addBusinessDays(start, days) {
    var date = new Date(start);
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return date;
  }

  function fill(el) {
    if (el.dataset.filled === 'true') return;
    var min = parseInt(el.dataset.minDays, 10);
    var max = parseInt(el.dataset.maxDays, 10);
    if (isNaN(min)) min = 3;
    if (isNaN(max)) max = 5;

    var today = new Date();
    var start = addBusinessDays(today, min);
    var end = addBusinessDays(today, max);

    var monthDay = { month: 'short', day: 'numeric' };
    var dayOnly = { day: 'numeric' };
    var sameMonth = start.getMonth() === end.getMonth();

    el.textContent =
      start.toLocaleDateString('en-US', monthDay) +
      '–' +
      end.toLocaleDateString('en-US', sameMonth ? dayOnly : monthDay);
    el.dataset.filled = 'true';
  }

  function init() {
    document.querySelectorAll('.pdp-shipping-policies .delivery-date').forEach(fill);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
